var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6946 4.49581L7.19032 3C7.34905 5.05055 8.80439 6.79292 10.83 7.29844C11.5982 7.49015 12.4018 7.49015 13.17 7.29844C15.1956 6.79292 16.6509 5.05055 16.8097 3L21.3054 4.49581C21.7913 4.65749 22.0806 5.15507 21.9801 5.65645L21.366 8.72179C21.2462 9.31976 20.6285 9.6776 20.049 9.48477L18.0936 8.83411V19.9862C18.0936 20.5461 17.6389 21 17.078 21H6.92201C6.36111 21 5.90641 20.5461 5.90641 19.9862V8.83411L3.95103 9.48477C3.3715 9.6776 2.7538 9.31976 2.634 8.72179L2.01985 5.65645C1.9194 5.15507 2.20868 4.65749 2.6946 4.49581ZM8.95321 13.6549C8.95321 14.7051 10.1778 15.8159 11.0743 16.4883C11.4801 16.7927 11.683 16.9449 12 16.9449C12.317 16.9449 12.5199 16.7927 12.9257 16.4883C13.8222 15.8159 15.0468 14.7051 15.0468 13.6549C15.0468 11.9004 13.371 11.2454 12 12.6007C10.629 11.2454 8.95321 11.9004 8.95321 13.6549Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72205 3.01348C10.8615 3.64447 13.1387 3.64447 15.2781 3.01348C15.1195 4.35905 14.1431 5.48808 12.8006 5.82311C12.275 5.95428 11.7252 5.95428 11.1996 5.82311C9.85707 5.48808 8.8807 4.35905 8.72205 3.01348Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt1);
export default __webpack_public_path__ + "static/media/shirt-1.54938dab67e547cc3050d0ccb34790fe.svg";
export { ForwardRef as ReactComponent };